/* eslint-disable */
import React from 'react'
import http from '../Interceptor/Interseptor'
import jMoment from 'moment-jalaali'
import {Checkbox, message} from 'antd'
import {Link} from 'react-router-dom'
import cookie from 'react-cookies'
import $ from 'jquery'
import {withRouter} from 'react-router-dom'
import HeaderTablePrint from '../BaseComponent/HeaderTablePrint'
import ExcelExport from '@progress/kendo-react-excel-export/dist/npm/ExcelExport'
import Loader from '../loaders/loader'
import {Modal, ModalBody, ModalFooter, ModalHeader} from 'mdbreact'
import {productShop} from '../../lib/path'

class DetailsReportEditedPrerecord extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      loading: true,
      wareHousesname: [],
      docType: [],
      errorForm: '',
      showTable: false,
      listWareHouse: [],
      preRecordInfo: {},
      urlQuery: '',
      providers: [],
      providerValue: '',
      selectedOption: [],
      wareType: [],
      report: [],
      fromDate: '',
      toDate: '',
      modalDelete: false,
      fromManual: '',
      toManual: '',
      printInfo: [],
      printFrom: '',
      printTo: '',
      buttonClicked: false,
      pageNumber: 1,
      pageSize: 10,
      countAll: 0,
      sortBy: '',
      getSort: '',
      sortData: [
        {
          name: 'ردیف',
          value: 'id',
          sorted: false,
          direction: null,
          sortable: false
        },
        {
          name: 'تاریخ ویرایش',
          value: 'created',
          sorted: true,
          direction: null,
          sortable: true
        },

        {
          name: 'وضعیت',
          value: 'rollBacked',
          sorted: false,
          direction: null,
          sortable: false
        },
        {
          name: 'تاریخ بازگشت',
          value: 'rolledBackTime',
          sorted: false,
          direction: null,
          sortable: true
        },
        {
          name: 'کاربر بازگشت کننده',
          value: 'rollBackOperatorId',
          sorted: false,
          direction: null,
          sortable: false
        },
        {
          name: 'جزییات',
          value: 'rollBackOperatorId',
          sorted: false,
          direction: null,
          sortable: false
        }
      ],
      operators: [],
      roleBackOperators: [],
      operatorId: '',
      rollBackOperatorId: ''
    }
  }

  submitForm(e) {
    e.preventDefault()
  }

  componentDidMount() {
    $(function() {
      $('.filterBtn').on('click', function() {
        $('.basketFilterComponent').slideToggle()
      })
    })

    sessionStorage.setItem('pageNumber', '1')
    sessionStorage.setItem('dropDownVal', '10')

    setTimeout(() => {
      this.getReport(false)
    }, 1500)
  }

  getReport = (exportStatus) => {
    this.setState({
      loading: true
    })
    let filter = this.createFilter(exportStatus)
    let {id} = this.props.match.params

    let urlParams = new URLSearchParams(window.location.search)
    let createDate = urlParams.get('createDate') === null ? '' : urlParams.get('createDate')
    let rolledBackTime = urlParams.get('rolledBackTime') === null ? '' : urlParams.get('rolledBackTime')
    http
      .get(`invoices/edition/get/${id}`, {
        params: filter
      })
      .then((response) => {
        if (response.data.error === null) {
          console.log(response.data)
          $('.showBaseTable,.print').fadeIn()
          this.setState({
            report: response.data.object,
            buttonClicked: true,
            createDate,
            rolledBackTime,
            loading: false,
            lengthList: response.data.object.countAll
          })
        } else {
          $('.showBaseTable,.print').fadeOut()
          this.setState({
            listWareHouse: [],
            lengthList: 0,
            loading: false
          })
          // message.error('خطای ' + response.data.errorCode + ' : ' + response.data.description)
        }
      })
      .catch((error) => {
        this.setState({
          loading: false
        })
      })
  }

  handleChangeFromDate = (fromDate) => {
    this.setState({
      fromDate
    })
  }

  handleChangeToDate = (toDate) => {
    this.setState({
      toDate
    })
  }

  componentDidUpdate(prevProps, prevState, snapshot) {
    if (prevState.pageNumber !== this.state.pageNumber) {
      this.getReport(false)
    }
    if (prevState.pageSize !== this.state.pageSize) {
      this.getReport(false)
    }
    if (prevState.sortBy !== this.state.sortBy) {
      this.getReport(false)
    }
  }

  getPageNumber = (pageNumber) => {
    this.setState({
      pageNumber
    })
  }

  getPageSize = (pageSize) => {
    this.setState({
      pageSize,
      pageNumber: 1
    })
  }
  getSort = (sortBy) => {
    this.setState({
      sortBy
    })
  }

  createFilter = (exportStatus) => {
    let filter = {}

    filter.export = exportStatus

    return filter
  }

  filter() {
    if (Object.keys(this.createFilter(false)).length - 3 === 0) {
      message.error('حداقل یک فیلتر وارد شود')
    } else {
      this.getReport(false)
    }
  }

  getPrintInfo = () => {
    this.setState({
      loading: true
    })
    let filter = this.createFilter(true)
    let {id} = this.props.match.params
    http
      .get(`invoices/edition/get/${id}`, {
        params: filter
      })
      .then((response) => {
        if (response.data.error == null) {
          $('.showBaseTable,.print').fadeIn()

          this.setState({
            printInfo: response.data.object.result,
            lengthList: response.data.object.countAll,
            loading: false
          })
        } else {
          this.setState({
            printInfo: [],
            loading: false
          })
        }
      })
      .catch((error) => {
        alert(JSON.stringify(error))
        this.setState({
          loading: false
        })
      })
  }

  exportPrint = () => {
    var css = '@page { size:A4 portrait;}',
      head = document.head || document.getElementsByTagName('head')[0],
      style = document.createElement('style')

    style.type = 'text/css'
    style.media = 'print'

    if (style.styleSheet) {
      style.styleSheet.cssText = css
    } else {
      style.appendChild(document.createTextNode(css))
    }

    head.appendChild(style)
    this.getPrintInfo()
    setTimeout(() => {
      window.print()
    }, 2000)
  }

  exportExcel = () => {
    let filter = this.createFilter(true)

    http
      .get(`invoices/edition/get`, {
        params: filter
      })
      .then((response) => {
        if (response.data.error == null) {
          this.setState({
            excelReport: response.data.object.result
          })
          let excelReport = this.state.excelReport
          for (let i = 0; i < excelReport.length; i++) {
            excelReport[i].created = jMoment(excelReport[i].created)
            if (excelReport[i].rolledBackTime !== null) {
              excelReport[i].rolledBackTime = jMoment(excelReport[i].rolledBackTime)
            }
            if (excelReport[i].rollBacked) {
              excelReport[i].rollBacked = 'بازگشت شده'
            } else {
              excelReport[i].rollBacked = 'بازگشت نشده'
            }
          }

          this._export.save(excelReport)
        }
      })
  }

  sendInvoice = (detailsId, firstName, lastName) => {
    this.setState({
      detailsId,
      invoiceModal: true,
      fullNameCustomer: firstName + ' ' + lastName
    })
  }

  sendInvoiceOk = () => {
    let {detailsId} = this.state
    http.patch(`invoices/edition/inform/${detailsId}`, {}).then((res) => {
      if (res.data.error === null) {
        message.success('اطلاع رسانی انجام شد')
        this.setState({
          invoiceModal: false,
          detailsId: ''
        })
        this.getReport(false)
      } else {
        message.error(res.data.description)
      }
    })
  }
  render() {
    const {loading} = this.state
    let name = cookie.load('name')
    let columns = ['ردیف', 'تاریخ ویرایش', 'وضعیت', 'تاریخ بازگشت', 'کاربر بازگشت کننده']

    return (
      <div className="rtl ">
        <Loader show={loading} />

        <div className="wrapperIframe">
          <ul className="breadcrumb">
            <li>
              <Link to={'/search'}>به روزرسان</Link>
            </li>
            <li>توزیع</li>
            <li>ویرایش فاکتورها</li>
            <li>مشاهده ویرایش های انجام شده</li>
            <li>جزییات</li>
          </ul>
          <div className="tableComponent">
            <div className="tableTools">
              <div className="detailsInfoTable">
                <ul>
                  <li>تاریخ ویرایش : {this.state.createDate}</li>
                  <li>تاریخ بازگشت : {this.state.rolledBackTime}</li>
                </ul>
              </div>
            </div>

            <div className="showBaseTable print">
              <table className="baseTable">
                <thead>
                  <tr>
                    <th>ردیف</th>
                    <th>شماره فاکتور</th>
                    <th>کالا</th>
                    <th>کد کالا</th>
                    <th>نام مشتری</th>
                    <th>کد مشتری</th>
                    <th>ویرایش</th>
                    <th>بازگشت</th>
                    <th>تعداد قبل از ویرایش</th>
                    <th>تعداد بعد از ویرایش</th>
                    <th>تاریخ اطلاع رسانی</th>
                  </tr>
                </thead>
                <tbody>
                  {this.state.report.map((item, index) => (
                    <tr key={index}>
                      <td>{index + 1}</td>
                      <td>{item.invoiceNum}</td>
                      <td>
                        {item.itemName}
                        {/* <a target='_blank' href={productShop({articleId: item.articleId})}>
                                                {item.itemName}
                                            </a> */}
                      </td>
                      <td>{item.articleId}</td>
                      <td>{item.firstName + ' ' + item.lastName}</td>
                      <td>{item.userCode}</td>
                      <td>
                        {item.edited ? (
                          <img src={require('../../image/confirm.svg')} title="ویرایش شده" />
                        ) : (
                          <img src={require('../../image/ignor.svg')} title="ویرایش نشده" />
                        )}
                      </td>
                      <td>
                        {item.rolledBack ? (
                          <img src={require('../../image/confirm.svg')} title="بازگشت داده شده" />
                        ) : (
                          <img src={require('../../image/ignor.svg')} title="بازگشت داده نشده" />
                        )}
                      </td>
                      <td>{item.quantityBeforeEdition}</td>
                      <td>{item.quantityAfterEdition}</td>
                      <td>{item.informTime !== null && jMoment(item.informTime).format('jYYYY/jM/jDD HH:mm')}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>
        </div>
        <Modal isOpen={this.state.invoiceModal} toggle={() => this.setState({invoiceModal: false})} size="md">
          <ModalHeader toggle={() => this.setState({invoiceModal: false})}>اطلاع رسانی</ModalHeader>
          <ModalBody>
            <p className="titleSm">
              <Checkbox
                className="form-check"
                name="confirmCheck"
                checked={this.state.confirmCheck}
                onChange={() => this.setState({confirmCheck: !this.state.confirmCheck})}
              >
                {'آیا از اطلاع رسانی به ' + this.state.fullNameCustomer + ' مطمئن هستید؟'}
              </Checkbox>
            </p>
          </ModalBody>
          <ModalFooter>
            <button
              disabled={this.state.confirmCheck ? false : true}
              className="confirmBtnModal"
              onClick={this.sendInvoiceOk}
            >
              تایید نهایی
            </button>
            <button className="cancelBtnModal" onClick={() => this.setState({invoiceModal: false})}>
              لغو
            </button>
          </ModalFooter>
        </Modal>
      </div>
    )
  }
}

export default withRouter(DetailsReportEditedPrerecord)
